module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1n4r8n-9280ed27358bb69ce236f2b4b459a6cb.svg";